import { useState } from "react";
import styles from "../styles/ReportsView.module.css";
import ReportsShifts from "./ReportsPages/ReportsShifts";
import ReportsCashiers from "./ReportsPages/ReportsCashiers";
import ReportsIncome from "./ReportsPages/ReportsIncome";
import ReportsABC from "./ReportsPages/ReportsABC";

const ReportsView = () => {
  const [activeTab, setActiveTab] = useState("shifts");

  const tabs = [
    { id: "shifts", label: "Отчеты по сменам" },
    { id: "cashiers", label: "Отчеты по кассирам" },
    { id: "income", label: "Доход и расход" },
    { id: "abc", label: "ABC анализ" },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "shifts":
        return <ReportsShifts />;
      case "cashiers":
        return <ReportsCashiers />;
      case "income":
        return <ReportsIncome />;
      case "abc":
        return <ReportsABC />;
      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`${styles.tabButton} ${
              activeTab === tab.id ? styles.active : ""
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.content}>{renderContent()}</div>
    </div>
  );
};

export default ReportsView;
